import { memo, useEffect } from "react";
import "./styles.scss";
import { useSelector } from "react-redux";
import {
  selectAudienceViewSlots,
  selectIsAudienceViewExpanded,
} from "modules/broadcast/AudienceView/selectors";
import ParticipantAvatar from "../ParticipantAvatar";
import { selectIsAudienceViewEnabled } from "../../../event/selectors";
import {
  AudienceViewEffects,
  useAudienceViewActions,
} from "../useAudienceView";

const PlaceholderNode = (
  <div className="audience-view-avatar-container">
    <div className="audience-view-avatar-image-container">
      <div className="audience-view-avatar-image-placeholder" />
    </div>
    <div className="audience-view-avatar-label">&nbsp;</div>
  </div>
);

const Placeholder = memo(() => PlaceholderNode);

const AudienceView = () => {
  const slots = useSelector(selectAudienceViewSlots);
  const itemsPerRow = slots.length / 2;
  const isExpanded = useSelector(selectIsAudienceViewExpanded);
  const { setIsContainerMounted } = useAudienceViewActions();
  const isAudienceViewEnabled = useSelector(selectIsAudienceViewEnabled);

  useEffect(() => {
    if (!isAudienceViewEnabled) return;

    setIsContainerMounted(true);
  }, [setIsContainerMounted, isAudienceViewEnabled]);

  if (!isAudienceViewEnabled) return null;

  const mapUsers = (userId: string | null, index: number) =>
    userId ? (
      <ParticipantAvatar userId={userId} key={userId} />
    ) : (
      <Placeholder key={index} />
    );

  return (
    <>
      <div
        id="audience-view-container"
        data-testid="audience-view-container"
        className={`audience-view-container ${isExpanded ? "expanded" : ""}`}
      >
        <div className="audience-view-avatar-list">
          <div className="audience-view-avatar-row">
            {slots.slice(0, itemsPerRow).map(mapUsers)}
          </div>
          <div className="audience-view-avatar-row">
            {slots.slice(itemsPerRow).map(mapUsers)}
          </div>
        </div>
      </div>
      <AudienceViewEffects />
    </>
  );
};

export default memo(AudienceView);
